<template>
    <form @submit.prevent="handleSubmit" :class="'form' + (theme !== '' ? ' form--' + theme : '')" novalidate>
        <input type="hidden" name="token" :value="$route.params.token" required />

        <div class="form-fieldset">
            <div class="form-group" :class="{ 'has-error': $v.form.password.$error, 'has-success': submitted && !$v.form.password.$error }" @keyup="$v.form.$touch()">
                <label class="u-sr-only" for="register-password">Wachtwoord</label>
                <input type="password" v-model="form.password" id="register-password" name="wachtwoord" class="form-control" placeholder="Vul hier je wachtwoord in" />
                <div v-if="$v.form.password.$error" class="form-validation">
                    <span v-if="!$v.form.password.required">Wachtwoord is verplicht</span>
                    <span v-if="!$v.form.password.minLength">Wachtwoord moet minstens 8 karakters lang zijn</span>
                    <span v-if="!$v.form.password.passwordValidatorUpper">Wachtwoord moet minstens 1 hoofdletter bevatten</span>
                    <span v-if="!$v.form.password.passwordValidatorInteger">Wachtwoord moet minstens 1 cijfer bevatten</span>
                    <span v-if="!$v.form.password.passwordValidatorSpecial">Wachtwoord moet minstens 1 speciaal teken bevatten</span>
                </div>
            </div>

            <div class="form-group" :class="{ 'has-error': $v.form.passwordRepeat.$error, 'has-success': submitted && !$v.form.passwordRepeat.$error }">
                <label class="u-sr-only" for="register-password-repeat">Herhaal wachtwoord</label>
                <input type="password" v-model="form.passwordRepeat" id="register-password-repeat" name="password-repeat" class="form-control" placeholder="Herhaal je wachtwoord" />
                <div v-if="$v.form.passwordRepeat.$error" class="form-validation">
                    <span v-if="!$v.form.passwordRepeat.required">Herhaal je wachtwoord</span>
                    <span v-else-if="!$v.form.passwordRepeat.sameAsPassword">Wachtwoorden moeten overeen komen</span>
                </div>
            </div>
        </div>

        <button type="submit" class="[ c-btn c-btn--info ] form-submit-btn" :disabled="status.loggingIn">
            <span v-show="status.sending">Bezig met versturen...</span>
            <span v-show="!status.sending">Verstuur</span>
            <svg v-show="!status.sending" xmlns="http://www.w3.org/2000/svg" width="15.589" height="12.389" viewBox="0 0 15.589 12.389">
                <g fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2">
                    <path d="M1 6.166h12.875"/>
                    <path d="M8.15 1.4l6.438 4.794-6.438 4.8" stroke-linejoin="round"/>
                    <path d="M8.15 1.399l6.438 4.795-6.437 4.8" stroke-linejoin="round"/>
                </g>
            </svg>
        </button>
    </form>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import { required, minLength, sameAs } from 'vuelidate/lib/validators';
    import normalizeFormData from '../../helpers/normalizeFormData';

    export default {
        name: 'ForgotPasswordResetForm',
        data () {
            return {
                form: {
                    password: '',
                    passwordRepeat: '',
                },
                submitted: false,
            };
        },
        props: {
            theme: {
                type: String,
                default: 'light',
            },
        },
        validations: {
            form: {
                password: {
                    required,
                    minLength: minLength(8),
                    // custom validator
                    passwordValidatorUpper: (password) => /[A-Z]/.test(password),
                    passwordValidatorInteger: (password) => /[0-9]/.test(password),
                    passwordValidatorSpecial: (password) => /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/.test(password),
                },
                passwordRepeat: { required, sameAsPassword: sameAs('password') },
            },
        },
        computed: {
            ...mapState('account', ['status']),
        },
        methods: {
            ...mapActions('account', ['passwordReset']),
            async handleSubmit (e) {
                this.submitted = true;

                // validate the form
                this.$v.form.$touch();

                // if its still pending or an error is returned do not submit
                if (this.$v.form.$pending || this.$v.form.$error) return;

                // normalize form data
                const data = normalizeFormData(e.target);

                // login
                await this.passwordReset(data);
            },
        },
    };
</script>
